// Shared order-status helpers — Firestore stores both capitalized ("Ready",
// "Picked Up", written by iOS) and lowercase ("ready", "pickedUp", written by
// web/Android) values, so every comparison must normalize first.
export const normalizeStatus = (s) =>
  (s || '').toString().toLowerCase().replace(/[\s_-]/g, '');

// iOS Order.isCompleted = completed || delivered. Cancelled orders still
// surface in the customer's Completed tab for record keeping.
export const COMPLETED_STATUSES = ['completed', 'delivered', 'cancelled'];

export const isActiveOrder = (order) =>
  !COMPLETED_STATUSES.includes(normalizeStatus(order?.status));

export const normalizeOrderType = (t) => (t || '').toString().toLowerCase();
